__turbopack_context__.v({
  "drag": "FileUploadGalleryDragged-module-scss-module__YqMbra__drag",
  "image": "FileUploadGalleryDragged-module-scss-module__YqMbra__image",
});
